﻿import { ResponseAlertasWeb } from '@/hooks/useNotifications.types';
import { GDTApiErrors } from '@/types';
import { axiosErrorHandler, TEXTS, URLs } from '@/utils';
import axiosGdt from '@/utils/axiosGdt';

export interface ResponseBase {
  estado: boolean;
  mensaje?: string;
  codError?: number;
}

export const getAlertasListado = axiosErrorHandler(
  async (tipoCliente: 'mobile' | 'desktop') => {
    const response = await axiosGdt.get<ResponseAlertasWeb | GDTApiErrors>(
      URLs.ALERTAS_WEB.LISTADO,
      { params: { tipoCliente } }
    );

    if (response.data.estado && response.data.alertas) {
      return response.data.alertas;
    }

    return [];
  },
  TEXTS.defaultError
);

export const marcarAlertasLeidas = axiosErrorHandler(
  async (idsAlertas: string) => {
    const formData = new URLSearchParams();
    formData.append('idsAlertas', idsAlertas);

    const response = await axiosGdt.post<ResponseBase | GDTApiErrors>(
      URLs.ALERTAS_WEB.MARCAR_LEIDAS,
      formData,
      { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } }
    );
    return response.data;
  },
  TEXTS.defaultError
);
